import { c as _c } from "react/compiler-runtime";
import { BaseButton } from '@7f-ui/components/button/button';
import { Flag } from '@7f-ui/components/flag/flag';
import { Modal } from '@7f-ui/components/modal/modal';
import type { NexperienceActivity, NexperienceSuitabiltyCategories } from '@data-access/graphql/schema.types';
import { useState } from 'react';
const EXPERIENCE_ACTIVITIES_LABELS: Record<string, string> = {
  adventure: 'Abenteuer',
  airborne: 'In der Luft',
  animals: 'Tiere',
  aquatics: 'Wassersport',
  art_and_culture: 'Kunst & Kultur',
  boats: 'Bootstouren',
  cycling: 'Radfahren',
  eat_and_drink: 'Essen & Trinken',
  entertainment: 'Unterhaltung',
  funsport: 'Funsport',
  guided_tours: 'Touren',
  hiking: 'Wandern',
  indoor: 'Indoor',
  learning: 'Neues lernen',
  mountaineering: 'Bergsport',
  music: 'Musik',
  nature: 'Natur pur',
  on_wheels: 'Auf Rädern',
  outdoor: 'Outdoor',
  photography: 'Fotografie',
  relaxation: 'Entspannung',
  rent: 'Mieten',
  running: 'Laufsport',
  sightseeing: 'Sehenswürdigkeiten',
  sport: 'Sport',
  tickets: 'Tickets',
  wellness: 'Wellness',
  winter_sports: 'Wintersport',
  yoga: 'Yoga'
};
const SUITABILTY_CATEGORIES_LABELS: Record<string, string> = {
  all_weather: 'Bei schlechtem Wetter',
  barrier_free: 'Barrierefrei',
  couples: 'Für Paare',
  dog: 'Mit Hund',
  for_adults: 'Für Erwachsene',
  for_children: 'Für Kinder',
  for_families: 'Für die ganze Familie',
  for_juveniles: 'Für Jugendliche',
  for_seniors: 'Für Senioren',
  groups: 'Für Gruppen',
  singles: 'Für Singles'
};
type AppExperienceAmenitySectionProps = {
  activities: NexperienceActivity[];
  suitableFor: NexperienceSuitabiltyCategories[];
};
export function AppExperienceAmenitySection(t0) {
  const $ = _c(21);
  const {
    activities,
    suitableFor
  } = t0;
  const [showModal, setShowModal] = useState(false);
  let t1;
  if ($[0] !== activities || $[1] !== suitableFor) {
    t1 = [...activities.map(_temp), ...suitableFor.map(_temp2)];
    $[0] = activities;
    $[1] = suitableFor;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const amenities = t1;
  if (amenities.length === 0) {
    return null;
  }
  let primaryAmenity;
  let restAmenities;
  if ($[3] !== amenities) {
    [primaryAmenity, ...restAmenities] = amenities;
    $[3] = amenities;
    $[4] = primaryAmenity;
    $[5] = restAmenities;
  } else {
    primaryAmenity = $[4];
    restAmenities = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setShowModal(true);
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== primaryAmenity) {
    t3 = <Flag variant="interactive" as={BaseButton} onClick={t2}><span className="font-base-copy">{primaryAmenity}</span></Flag>;
    $[7] = primaryAmenity;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== restAmenities.length) {
    t4 = restAmenities.length > 0 && <Flag variant="interactive" as={BaseButton} onClick={() => setShowModal(true)}>+{restAmenities.length}</Flag>;
    $[9] = restAmenities.length;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="flex gap-1">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setShowModal(false);
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== amenities || $[16] !== showModal) {
    t7 = <ExperienceAmenitiesModal amenities={amenities} open={showModal} onClose={t6} />;
    $[15] = amenities;
    $[16] = showModal;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp2(suitabilty) {
  return SUITABILTY_CATEGORIES_LABELS[suitabilty] ?? suitabilty;
}
function _temp(activity) {
  return EXPERIENCE_ACTIVITIES_LABELS[activity] ?? activity;
}
function ExperienceAmenitiesModal(t0) {
  const $ = _c(11);
  const {
    amenities,
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = <Modal.Header onClose={onClose}>Kategorien</Modal.Header>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== amenities) {
    t2 = amenities.map(_temp3);
    $[2] = amenities;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Modal.Content><div className="flex flex-wrap gap-2">{t2}</div></Modal.Content>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClose || $[7] !== open || $[8] !== t1 || $[9] !== t3) {
    t4 = <Modal isOpen={open} onClose={onClose}>{t1}{t3}</Modal>;
    $[6] = onClose;
    $[7] = open;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp3(amenity) {
  return <Flag key={amenity}>{amenity}</Flag>;
}